import { WorkspaceGroup } from '../../store/common/workspaceScheme/types';
import { HitData } from '../../store/common/search/types';
import { TabItem, CustomListSetting } from '../../types/TabTypes';
import { TableOptions } from './types';

export enum TypeKeys {
    TOGGLE_SORT = 'table/TOGGLE_SORT',
    DATA_LOADED = 'table/DATA_LOADED',
    CHILD_DATA_LOADED = 'table/CHILD_DATA_LOADED',
    SET_INIT_DATA = 'table/SET_INIT_DATA',
    PAGE_CHANGE = 'table/PAGE_CHANGE',
    SET_HITS_PER_PAGE = 'table/SET_HITS_PER_PAGE',
    SECTIONS_LOADED = 'table/SECTIONS_LOADED',
    LOAD_DATA = 'table/LOAD_DATA',
    TAB_ITEM_CLICK = 'table/TAB_ITEM_CLICK',
    HELP = 'table/HELP',
    ADD_NEW_TAB = 'table/ADD_NEW_TAB',
    FILTER_COLUMNS = 'table/FILTER_COLUMNS',
    SEARCH_INPUT_CHANGE = 'table/SEARCH_INPUT_CHANGE',
    CHECK_ALL_COLUMNS = 'table/CHECK_ALL_COLUMNS',
    TOGGLE_EDIT_MODE = 'table/TOGGLE_EDIT_MODE',
    SELECT_HIT = 'table/SELECT_HIT',
    LOAD_USER_WORKSPACES = 'table/LOAD_USER_WORKSPACES',
    EDIT_FILTER = 'table/EDIT_FILTER',
    ADD_FILTER = 'table/ADD_FILTER',
    REMOVE_FILTER = 'table/REMOVE_FILTER',
    TOGGLE_TABNAME_EDITING = 'table/TOGGLE_TABNAME_EDITING',
    CHANGE_TABNAME = 'table/CHANGE_TABNAME',
    FETCH_OPTIONS_FOR_FILTER = 'table/FETCH_OPTIONS_FOR_FILTER',
    LOAD_OPTIONS_FOR_FILTER = 'table/LOAD_OPTIONS_FOR_FILTER',
    LOAD_OPTIONS_FOR_NEW_FILTER = 'table/LOAD_OPTIONS_FOR_NEW_FILTER',
    LOAD_CUSTOM_TABS = 'table/LOAD_CUSTOM_TABS',
    SAVE_TAB = 'table/SAVE_TAB',
    CLONE_TAB = 'table/CLONE_TAB',
    CHANGE_TAB_ID = 'table/CHANGE_TAB_ID',
    RESET_TAB = 'table/RESET_TAB',
    REMOVE_TAB = 'table/REMOVE_TAB',
    UPDATE_LIST = 'table/UPDATE_LIST',
    REMOVE_COLUMN_FROM_LIST = 'table/REMOVE_COLUMN_FROM_LIST',
    TOGGLE_COLUMN_LIST = 'table/TOGGLE_COLUMN_LIST',
    VIEW_COLUMN_EDITING_OVERLAY = 'table/VIEW_COLUMN_EDITING_OVERLAY',
    HIDE_COLUMN_EDITING_OVERLAY = 'table/HIDE_COLUMN_EDITING_OVERLAY',
    LOAD_CUSTOM_LIST = 'table/LOAD_CUSTOM_LIST',
    RESTORE_DEFAULT_LIST = 'table/RESTORE_DEFAULT_LIST',
    ADD_UPLOAD_QUESTION_INFO = 'table/ADD_UPLOAD_QUESTION_INFO',
    RESTORE_ALL_DEFAULTS = 'table/RESTORE_ALL_DEFAULT',
    UPDATE_COLUMNS = 'table/UPDATE_COLUMNS',
    UPDATE_SEARCH_QUERY_BY_VIEW = 'table/UPDATE_SEARCH_QUERY_BY_VIEW',
    FETCH_OPTIONS_FOR_NEW_FILTER = 'table/FETCH_OPTIONS_FOR_NEW_FILTER',
}

export interface RestoreAllDefaultsAction {
    type: TypeKeys.RESTORE_ALL_DEFAULTS;
    featureId: string;
}

export interface ResetTabAction {
    type: TypeKeys.RESET_TAB;
    featureId: string;
    filterId?: number;
}

export interface RemoveTabAction {
    type: TypeKeys.REMOVE_TAB;
    featureId: string;
    filterId?: number;
}

export interface CloneTabAction {
    type: TypeKeys.CLONE_TAB;
    tabId: string;
    tabName: string;
    featureId: string;
}

export interface ChangeTabId {
    type: TypeKeys.CHANGE_TAB_ID;
    oldTabId: string;
    newTabId: string;
    featureId: string;
}

export interface SaveTabAction {
    type: TypeKeys.SAVE_TAB;
    featureId: string;
}

export interface LoadCustomTabsAction {
    type: TypeKeys.LOAD_CUSTOM_TABS;
    featureId: string;
    customTabs: any[];
}

export interface RestoreDefaultListAction {
    type: TypeKeys.RESTORE_DEFAULT_LIST;
    featureId: string;
}

export interface LoadCustomListAction {
    type: TypeKeys.LOAD_CUSTOM_LIST;
    featureId: string;
    customList: CustomListSetting;
}

export interface ViewColumnEditOverlay {
    type: TypeKeys.VIEW_COLUMN_EDITING_OVERLAY;
    featureId: string;
}

export interface HideColumnEditOverlay {
    type: TypeKeys.HIDE_COLUMN_EDITING_OVERLAY;
    featureId: string;
}

export interface UpdateListAction {
    type: TypeKeys.UPDATE_LIST;
    featureId: string;
    dragIndex: number;
    hoverIndex: number;
}

export interface RemoveColumnFromList {
    type: TypeKeys.REMOVE_COLUMN_FROM_LIST;
    featureId: string;
    columnRef: string;
}

export interface ToggleColumnListAction {
    type: TypeKeys.TOGGLE_COLUMN_LIST;
    featureId: string;
    columnRef: string;
}

export interface FetchOptionsForFilterAction {
    type: TypeKeys.FETCH_OPTIONS_FOR_FILTER;
    featureId: string;
    filterName: string;
    value: any;
}

export interface FetchOptionsForNewFilterAction {
    type: TypeKeys.FETCH_OPTIONS_FOR_NEW_FILTER;
    featureId: string;
    param?: string;
    sourcePath: string;
    append?: boolean;
}

export interface LoadOptionsForFilterAction {
    type: TypeKeys.LOAD_OPTIONS_FOR_FILTER;
    featureId: string;
    filterName: string;
    options: any[];
}

export interface LoadOptionsForNewFilterAction {
    type: TypeKeys.LOAD_OPTIONS_FOR_NEW_FILTER;
    featureId: string;
    sourcePath: string;
    append?: boolean;
    options: any[];
}

export interface ChangeTabNameAction {
    type: TypeKeys.CHANGE_TABNAME;
    featureId: string;
    tabId: string;
    newName: string;
}

export interface ToggleTabNameEditingAction {
    type: TypeKeys.TOGGLE_TABNAME_EDITING;
    featureId: string;
    tabId: string;
}

export interface AddFilterAction {
    type: TypeKeys.ADD_FILTER;
    featureId: string;
    temporalName: string;
    tabId: string;
}

export interface RemoveFilterAction {
    type: TypeKeys.REMOVE_FILTER;
    featureId: string;
    filterName: string;
    tabId: string;
}

export interface EditFilterAction {
    type: TypeKeys.EDIT_FILTER;
    featureId: string;
    newFilter: any;
    tabId: string;
}

export interface SelectHitAction {
    type: TypeKeys.SELECT_HIT;
    featureId: string;
    hit: HitData;
}

export interface ToggleSortAction {
    type: TypeKeys.TOGGLE_SORT;
    featureId: string;
    column: string;
}

export interface DataLoadedAction {
    type: TypeKeys.DATA_LOADED;
    featureId: string;
    data: any;
}

export interface ChildDataLoadedAction {
    type: TypeKeys.CHILD_DATA_LOADED;
    featureId: string;
    data: any;
}

export interface PageChangeAction {
    type: TypeKeys.PAGE_CHANGE;
    featureId: string;
    activePage: number;
    isSelectionState?: boolean;
    selectedItems?: HitData[];
}

export interface HitsPerPageChangeAction {
    type: TypeKeys.SET_HITS_PER_PAGE;
    featureId: string;
    value: number;
    isSelectionState?: boolean;
    selectedItems?: HitData[];
}

export interface LoadDataAction {
    type: TypeKeys.LOAD_DATA;
    featureId: string;
}

export interface SetInitDataAction {
    type: TypeKeys.SET_INIT_DATA;
    featureId: string;
    tableOptions: TableOptions;
}

export interface TabItemClickAction {
    type: TypeKeys.TAB_ITEM_CLICK;
    selectedTab: TabItem;
    additionalContext: any;
    featureId: string;
}

export interface ToggleEditModeAction {
    type: TypeKeys.TOGGLE_EDIT_MODE;
    featureId: string;
}

export interface HelpAction {
    type: TypeKeys.HELP;
    featureId: string;
}

export interface AddNewTabAction {
    type: TypeKeys.ADD_NEW_TAB;
    featureId: string;
    tabId: string;
    tabName: string;
}

export interface FilterColumnsAction {
    type: TypeKeys.FILTER_COLUMNS;
    featureId: string;
}

export interface SearchInputChangeAction {
    type: TypeKeys.SEARCH_INPUT_CHANGE;
    featureId: string;
    text: string;
}

export interface ToggleCheckAllColumnsAction {
    type: TypeKeys.CHECK_ALL_COLUMNS;
    featureId: string;
}

export interface LoadUserWorkspaces {
    type: TypeKeys.LOAD_USER_WORKSPACES;
    featureId: string;
    availableWorkspaces: WorkspaceGroup[];
}

export interface SectionsLoadedAction {
    type: TypeKeys.SECTIONS_LOADED;
    featureId: string;
    data: any;
}

export interface UpdateColumnsAction {
    type: TypeKeys.UPDATE_COLUMNS;
    viewType: string;
    featureId: string;
}

export interface UpdateSearchQueryByViewAction {
    type: TypeKeys.UPDATE_SEARCH_QUERY_BY_VIEW;
    viewType: string;
    featureId: string;
}

export type ActionTypes = | ToggleSortAction | DataLoadedAction | ChildDataLoadedAction | PageChangeAction | LoadDataAction |
    SetInitDataAction | TabItemClickAction | HelpAction |
    ToggleCheckAllColumnsAction | SearchInputChangeAction | ToggleEditModeAction
    | HitsPerPageChangeAction | SectionsLoadedAction
    | SelectHitAction | LoadUserWorkspaces
    | EditFilterAction | AddFilterAction | RemoveFilterAction | ToggleTabNameEditingAction
    | ChangeTabNameAction | FetchOptionsForFilterAction | LoadOptionsForFilterAction | LoadCustomTabsAction
    | SaveTabAction | CloneTabAction | ChangeTabId | ResetTabAction | RemoveTabAction | AddNewTabAction
    | UpdateListAction | RemoveColumnFromList | ToggleColumnListAction
    | ViewColumnEditOverlay | HideColumnEditOverlay | LoadCustomListAction
    | RestoreDefaultListAction | RestoreAllDefaultsAction
    | UpdateColumnsAction | UpdateSearchQueryByViewAction | FetchOptionsForNewFilterAction
    | LoadOptionsForNewFilterAction;

export const sectionsLoaded = (featureId: string, data: any): SectionsLoadedAction => ({
    featureId,
    data,
    type: TypeKeys.SECTIONS_LOADED,
});

export const restoreAllDefaults = (featureId: string): RestoreAllDefaultsAction => ({
    featureId,
    type: TypeKeys.RESTORE_ALL_DEFAULTS,
});

export const loadUserWorkspaces = (featureId: string, availableWorkspaces: WorkspaceGroup[]): LoadUserWorkspaces => ({
    featureId,
    availableWorkspaces,
    type: TypeKeys.LOAD_USER_WORKSPACES,
});

export const resetTab = (featureId: string, filterId?: number): ResetTabAction => ({
    featureId,
    filterId,
    type: TypeKeys.RESET_TAB,
});

export const removeTab = (featureId: string, filterId?: number): RemoveTabAction => ({
    featureId,
    filterId,
    type: TypeKeys.REMOVE_TAB,
});

export const cloneTab = (featureId: string, tabId: string, tabName: string): CloneTabAction => ({
    featureId,
    tabId,
    tabName,
    type: TypeKeys.CLONE_TAB,
});

export const changeTabId = (featureId: string, oldTabId: string, newTabId: string): ChangeTabId => ({
    featureId,
    oldTabId,
    newTabId,
    type: TypeKeys.CHANGE_TAB_ID,
});

export const saveTab = (featureId: string): SaveTabAction => ({
    featureId,
    type: TypeKeys.SAVE_TAB,
});

export const loadCustomTabs = (featureId: string, customTabs: any[]): LoadCustomTabsAction => ({
    featureId,
    customTabs,
    type: TypeKeys.LOAD_CUSTOM_TABS,
});

export const restoreDefaultList = (featureId: string): RestoreDefaultListAction => ({
    featureId,
    type: TypeKeys.RESTORE_DEFAULT_LIST,
});

export const loadCustomList = (featureId: string, customList: CustomListSetting): LoadCustomListAction => ({
    featureId,
    customList,
    type: TypeKeys.LOAD_CUSTOM_LIST,
});

export const viewColumnsOverlay = (featureId: string): ViewColumnEditOverlay => ({
    featureId,
    type: TypeKeys.VIEW_COLUMN_EDITING_OVERLAY,
});

export const hideColumnsOverlay = (featureId: string): HideColumnEditOverlay => ({
    featureId,
    type: TypeKeys.HIDE_COLUMN_EDITING_OVERLAY,
});

export const updateList = (featureId: string, dragIndex: number, hoverIndex: number): UpdateListAction => ({
    featureId,
    dragIndex,
    hoverIndex,
    type: TypeKeys.UPDATE_LIST,
});

export const removeColumnFromList = (featureId: string, columnRef: string): RemoveColumnFromList => ({
    featureId,
    columnRef,
    type: TypeKeys.REMOVE_COLUMN_FROM_LIST,
});

export const toggleColumnFromList = (featureId: string, columnRef: string): ToggleColumnListAction => ({
    featureId,
    columnRef,
    type: TypeKeys.TOGGLE_COLUMN_LIST,
});

export const loadOptionsForFilter = (featureId: string, filterName: string, options: string[]): LoadOptionsForFilterAction => ({
    featureId,
    filterName,
    options,
    type: TypeKeys.LOAD_OPTIONS_FOR_FILTER,
});

export const loadOptionsForNewFilter = (featureId: string,
    sourcePath: string,
    options: string[],
    append?: boolean): LoadOptionsForNewFilterAction => ({
    featureId,
    sourcePath,
    options,
    append,
    type: TypeKeys.LOAD_OPTIONS_FOR_NEW_FILTER,
});

export const fetchOptionsForFilter = (featureId: string, filterName: string, value: any): FetchOptionsForFilterAction => ({
    featureId,
    filterName,
    value,
    type: TypeKeys.FETCH_OPTIONS_FOR_FILTER,
});

export const fetchOptionsForNewFilter = (featureId: string, sourcePath: string, param?: any, append?: boolean): FetchOptionsForNewFilterAction => ({
    featureId,
    sourcePath,
    param,
    append,
    type: TypeKeys.FETCH_OPTIONS_FOR_NEW_FILTER,
});

export const changeTabName = (featureId: string, tabId: string, newName: string): ChangeTabNameAction => ({
    featureId,
    tabId,
    newName,
    type: TypeKeys.CHANGE_TABNAME,
});

export const toggleTabNameEditing = (featureId: string, tabId: string): ToggleTabNameEditingAction => ({
    featureId,
    tabId,
    type: TypeKeys.TOGGLE_TABNAME_EDITING,
});

export const addFilter = (featureId: string, tabId: string, temporalName: string): AddFilterAction => ({
    featureId,
    temporalName,
    tabId,
    type: TypeKeys.ADD_FILTER,
});

export const removeFilter = (featureId: string, tabId: string, filterName: string): RemoveFilterAction => ({
    featureId,
    filterName,
    tabId,
    type: TypeKeys.REMOVE_FILTER,
});

export const editFilter = (featureId: string, tabId: string, newFilter: any): EditFilterAction => ({
    featureId,
    newFilter,
    tabId,
    type: TypeKeys.EDIT_FILTER,
});

export const selectHit = (featureId: string, hit: HitData): SelectHitAction => ({
    featureId,
    hit,
    type: TypeKeys.SELECT_HIT,
});

export const toggleSortColumn = (featureId: string, column: string): ToggleSortAction => ({
    featureId,
    column,
    type: TypeKeys.TOGGLE_SORT,
});

export const dataLoaded = (featureId: string, data: any): DataLoadedAction => ({
    data,
    featureId,
    type: TypeKeys.DATA_LOADED,
});

export const childDataLoaded = (featureId: string, data: any): ChildDataLoadedAction => ({
    data,
    featureId,
    type: TypeKeys.CHILD_DATA_LOADED,
});

export const hitsPerPageChange = (featureId: string, value: number, isSelectionState?: boolean, selectedItems?: HitData[]):
HitsPerPageChangeAction => ({
    featureId,
    value,
    isSelectionState,
    selectedItems,
    type: TypeKeys.SET_HITS_PER_PAGE,
});

export const pageChange = (featureId: string, activePage: number, isSelectionState?: boolean, selectedItems?: HitData[]): PageChangeAction => ({
    featureId,
    activePage,
    isSelectionState,
    selectedItems,
    type: TypeKeys.PAGE_CHANGE,
});

export const loadData = (featureId: string): LoadDataAction => ({
    featureId,
    type: TypeKeys.LOAD_DATA,
});

export const setInitData = (featureId: string, tableOptions: TableOptions): SetInitDataAction => ({
    featureId,
    tableOptions,
    type: TypeKeys.SET_INIT_DATA,
});

export const tabItemClick = (
    featureId: string, selectedTab: TabItem, additionalContext: any
): TabItemClickAction => ({
    featureId,
    selectedTab,
    // needed for specific filter handling
    additionalContext,
    type: TypeKeys.TAB_ITEM_CLICK,
});

export const toggleEditMode = (featureId: string): ToggleEditModeAction => ({
    featureId,
    type: TypeKeys.TOGGLE_EDIT_MODE,
});

export const help = (featureId: string): HelpAction => ({
    featureId,
    type: TypeKeys.HELP,
});
export const addNewTab = (featureId: string, tabId: string, tabName: string): AddNewTabAction => ({
    featureId,
    tabId,
    tabName,
    type: TypeKeys.ADD_NEW_TAB,
});
export const filterColumns = (featureId: string): FilterColumnsAction => ({
    featureId,
    type: TypeKeys.FILTER_COLUMNS,
});

export const searchInputChange = (featureId: string, text: string): SearchInputChangeAction => ({
    featureId,
    text,
    type: TypeKeys.SEARCH_INPUT_CHANGE,
});

export const toggleCheckAll = (featureId: string): ToggleCheckAllColumnsAction => ({
    featureId,
    type: TypeKeys.CHECK_ALL_COLUMNS,
});

export const updateColumns = (featureId: string, viewType: string): UpdateColumnsAction => ({
    featureId,
    viewType,
    type: TypeKeys.UPDATE_COLUMNS,
});

export const updateSearchQueryByView = (featureId: string, viewType: string): UpdateSearchQueryByViewAction => ({
    featureId,
    viewType,
    type: TypeKeys.UPDATE_SEARCH_QUERY_BY_VIEW,
});
